<template>
    <div>
        <!-- 点击 Report information errors 后弹出 -->
        <div class="deep">
            <el-dialog :visible.sync="newDialog" center :close-on-click-modal="true" @close="closeDialog"
                custom-class="dialog_normalsuo " :append-to-body="true">
                <div class="detail_cont">
                    <h3>Save Your Portfolio</h3>

                    <div class="rep_list">
                        <el-form   ref="CustomObj" :model="CustomObj" class="report_form" :rules="rules">
                            <div class="report_item">
                                <div class="report_form_box">
                                    <div class="form_box">
                                        <div class="fin_cont_box flex_center_between_box">
                                            <div class="fin_modu_box">
                                                <div class="fin_modu">
                                                    <el-form-item label="Portfolio Name"  prop="portfolioName">
                                                        <el-input v-if="myDataMnegent" placeholder=" Enter Portfolio Name"  
                                                            v-model="CustomObj.portfolioName"></el-input>
                                                              <el-select v-if="!myDataMnegent" v-model="portfolioNameValue"  style="width: 100%;" filterable allow-create
                                                        default-first-option @change="portfolioNameValueChange" placeholder=" Enter/Select Portfolio Name">
                                                        <el-option v-for="item in yourUsagelist" :key="item.id"
                                                            :label="item.portfolioName" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                    </el-form-item>
                                                  

                                                    <el-form-item label="User Name"  prop="userName">
                                                        <el-input placeholder="Enter User Name"
                                                            v-model="CustomObj.userName"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Task Name"  prop="groupTask">
                                                                    <el-select v-model="CustomObj.groupTask"  style="width: 100%;" filterable  
                                                        default-first-option @change="GroupTaskChange" placeholder="Select Task Name">
                                                        <el-option v-for="(item,index) in groupTaskLsit" :key="index"
                                                            :label="item.groupTaskName" :value="item.groupTaskName">
                                                        </el-option>
                                                    </el-select>
                                                        <!-- <el-input placeholder="Enter Group Task"
                                                            v-model="CustomObj.groupTask"></el-input> -->
                                                    </el-form-item>
                                                    <el-form-item label="Notes">
                                                        <el-input placeholder="Enter Notes"
                                                            v-model="CustomObj.executorName"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div style="display: flex; justify-content: center">
                                    <el-button class="btn_cancel" @click="cancelReport()">Cancel</el-button>
                                    <el-button class="btn_export" @click="onSubmitReport('CustomObj')">Submit</el-button>
                                    <!-- <el-button class="btn_export" :disabled="disabledReport" @click="onSubmitReport()">Submit</el-button> -->
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { editPortfolio,changePortfolio,createPortfolio } from '@/api/companyApi.js';
import { getqueryPortfolio } from "@/api/userApi";

export default {
    props: {
        showReport: {
            type: Boolean,
            default: false,
        },
        CustomObj: {
            type: Object,

        },
        myDataMnegent: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            portfolioNameValue:'',
               token: localStorage.getItem("token"),
            form: {
                CompanyName: '',
                Country: '',
                RegisterID: '',
                Address: '',
                demand: '',
            },
              rules: {
      
     
          portfolioName: [
            {  required: true, message: ' Enter Portfolio Name', trigger: 'change' }
          ],
             userName: [
            {  required: true, message: ' Enter User Name', trigger: 'blur' }
          ],
            groupTask: [
            {  required: true, message: ' Enter User Name', trigger: 'change' }
          ],
    
         
        },
            type: '701',
            yourUsagelist:[],
            indexOfValue:[],
            groupTaskLsit:[
                {
                    groupTaskName:'Main body monitoring',

                },
                   {
                    groupTaskName:'Data analysis',

                },
            ],
            reportForm: { subject: '', demand: '' },
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.showReport;
            },
            set(newValue) { },
        },
    },

    mounted() {
       this.token ? this.getgetUserActionLogPage():''

    },
    methods: {
  GroupTaskChange(){

  },
        portfolioNameValueChange(){
      
           this.indexOfValue= this.yourUsagelist.filter(item=>item.id==this.portfolioNameValue)
            if(this.indexOfValue.length>0){
                 this.$parent.CustomObj=this.indexOfValue[0]
            }else{
                 this.$parent.CustomObj={
                groupTask: '',
                executorName: '',
                portfolioName:this.portfolioNameValue,
                userName: '',
                id: ""
                 }
            }
        },
        // 获取我的组合数据
        getgetUserActionLogPage() {
            getqueryPortfolio().then((res) => {
                if (res.code == 200) {
                    this.yourUsagelist = res.data;
                } else {
                    this.yourUsagelist = [];
                }
            }).catch(err => {
                this.reLoginVis = String(err).includes('403')
            });

        },

        //关闭弹窗
        closeDialog() {

            this.form.RegisterID = '',
                this.form.Country = ''
            this.form.demand = ''
            this.form.Address = ''
            this.$emit('closeReportDialog', false);
        },


        //提交report
        onSubmitReport(formName) {
              this.$refs[formName].validate((valid) => {
                console.log('valid');
                
          if (valid) {
           this.hanldSubmitReport();

          } else {
            return false;
          }
        });
        },
        async hanldSubmitReport() {

let Updatelis = []
  this.$store.state.app.changeList.map((item) => {
                Updatelis.push(
                    item.aaa_id
                );
  })
            let obj = {
                id: this.CustomObj.id,
                portfolio:{
                 aaaIds:Updatelis
                },
                portfolioName: this.CustomObj.portfolioName,
                userName: this.CustomObj.userName,
                groupTask: this.CustomObj.groupTask,
                executorName: this.CustomObj.executorName,
            };

            this.closeDialog();
            let res={

            }
            if( this.myDataMnegent){
               res = await  editPortfolio(obj);

            }else{
             res = await createPortfolio(obj);

            }
            if (res.code == 200) {
                if(!this.myDataMnegent){
                // this.ChangeProto()

                }
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'success',
                });

            } else {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'error',
                });
            }
        },
        //取消report
        cancelReport() {
            this.closeDialog();

        },
    },
};
</script>
<style scoped>
.form_box /deep/ .el-input__inner {
    width: 162px;
    height: 34px;
    line-height: 34px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e7eaed;
    font-size: 1.2857143rem;
}






.form_box /deep/ .el-select .el-icon-arrow-up:before {
    color: #8497ab !important;
}


.fin_modu.last {
    height: 661px;
}

.form_box /deep/ .el-form-item__content {
    line-height: 34px;
    margin-left: 162px;
    font-size: 1.2857143rem;
}

/deep/ .el-form-item__label {
    color: #1A2332;
    font-size: 1.2857143rem;
    margin-bottom: 10px;
}

.form_box /deep/ .el-form-item__label {
    display: flex;
    align-items: center;
    color: #1A2332;
    font-size: 1.2857143rem;
    height: 50px;
    line-height: 50px;


}

.form_box /deep/ .el-form-item {
    margin-bottom: 12px;
    display: inline-block;
    font-size: 1.2857143rem;
    width: 100% !important;
}


.form_box /deep/ .out_item {
    margin-bottom: 20px;
}

.form_box /deep/ .el-input__icon {
    height: auto;
}



.rep_list {
    padding-bottom: 10px;
}



.report_form_box {
    margin-top: 1.4285714rem;
    margin-bottom: 20px;

}

.report_form /deep/ .el-input__inner {
    width: 100%;
    height: 50px;
    line-height: 50px;
}

.report_form /deep/ .el-form-item {
    margin-bottom: 20px;
}

.limit_box /deep/ .el-textarea__inner {
    height: 150px;
}

.detail_cont {}
</style>
